"use client";

import React from "react";
import { Eye, Edit, Trash2, MoreHorizontal } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { Customer } from "@/types/models/customer";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { deleteCustomerRequest } from "@/store/slices/customer.slice";

interface CustomerActionsCellProps {
  customer: Customer;
}

const CustomerActionsCell: React.FC<CustomerActionsCellProps> = ({
  customer,
}) => {
  const navigate = useNavigate();
  const params = useParams();
  const dispatch = useDispatch();

  const handleView = () => {
    const storeType = params?.storeType as string;
    const storeId = params?.storeId as string;
    navigate(`/${storeType}/${storeId}/customers/${customer.id}`);
  };

  const handleEdit = () => {
    const storeType = params?.storeType as string;
    const storeId = params?.storeId as string;
    navigate(`/${storeType}/${storeId}/customers/${customer.id}/edit`);
  };

  const handleDelete = () => {
    if (
      confirm(
        `Are you sure you want to delete customer ${customer.first_name} ${customer.last_name}?`,
      )
    ) {
      dispatch(deleteCustomerRequest({ customerId: customer.id }));
    }
  };

  return (
    <div className="flex items-center gap-2">
      <Button
        variant="ghost"
        size="sm"
        onClick={handleView}
        className="h-8 w-8 p-0"
      >
        <Eye className="h-4 w-4" />
      </Button>

      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="sm" className="h-8 w-8 p-0">
            <MoreHorizontal className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onClick={handleView}>
            <Eye className="mr-2 h-4 w-4" />
            View Details
          </DropdownMenuItem>
          <DropdownMenuItem onClick={handleEdit}>
            <Edit className="mr-2 h-4 w-4" />
            Edit Customer
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={handleDelete} className="text-destructive">
            <Trash2 className="mr-2 h-4 w-4" />
            Delete Customer
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default CustomerActionsCell;
